<template>
  <!-- 画面上部のツールバー。 -->
  <div
    class="toolbar"
  >
    <v-btn
      v-show="screenSize === 'small'"
      icon
      flat
      color="tertiary"
      class="ma-0"
      @click.stop="onClickBtn"
    >
      <v-icon>mdi-view-list</v-icon>
    </v-btn>

    <DataTimer />
    <div class="items">
      <!-- <Notifications /> -->
      <Announcement />
      <PersonalMenu />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { PersonalMenu, DataTimer, Announcement } from './AppToolbar/index'

export default {
  components: {
    PersonalMenu,
    DataTimer,
    Announcement
  },
  computed: {
    ...mapState('display', ['screenSize'])
  },
  methods: {
    ...mapMutations('display', ['toggleDrawer']),
    onClickBtn () {
      this.toggleDrawer()
    }
  }
}
</script>

<style lang="scss" scoped>
  .toolbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    height: 50px;
    background-color: var(--metal-blue-l);
    z-index: 100;
    padding: 6px 18px;
    border-bottom: 1px solid var(--metal-blue);

    .items {
      display: flex;
      margin-left: auto;
      margin-right: 0;
    }
  }
</style>
